import { TransactionItemDrawerMode } from '@/features/transaction_items/List/type';
import { TooltipInput } from '@/features/transaction_items/components/Form/GeneralForm/TooltipInput/TooltipInput';
import { FC, memo } from 'react';

export type Props = {
  mode: TransactionItemDrawerMode;
};

export const Pulldown: FC<Props> = memo(({ mode }) => {
  return <TooltipInput mode={mode} />;
});
Pulldown.displayName = 'Pulldown';
